
import {storage} from "utils"
import { tokensdb } from "internal/indexeddb"
import axios from "axios"
import { default as routes} from "api/routes"

const accessTokenKey = "msc.session.access.token"
const refreshTokenKey = "refreshToken"
export const prefixToken = "Bearer"

export function lastAccessToken(): string {
	return storage.load(accessTokenKey)
}

export function deleteAccessToken(): void {
	storage.remove(accessTokenKey)
}

export function updateAccessToken(value: string): void {
	storage.update(accessTokenKey, value)
}

export const saveRefreshToken = (token: string) => {
    return tokensdb.put({ id: refreshTokenKey, value: token })
      .then(() => console.debug("Token saved"))
      .catch(() => console.error("Error saving token"))
}

export const getRefreshToken = () => {
    return tokensdb.get(refreshTokenKey)
      .then((result) => {
        return result ? result.value : null})
      .catch(() => null)
}

export const deleteRefreshToken = () => {
    return tokensdb.delete(refreshTokenKey)
      .then(() => console.debug("Token deleted"))
      .catch(() => console.error("Error deleting token"))
}

export const headerToken = (token: string) => {
  return {
    'Authorization': `${prefixToken} ${token}`
  }
}

class TokenRefresher {
  private isRefreshing = false
  private refreshSubscribers: Array<(token: string) => void> = []

  private addRefreshSubscriber(callback: (token: string) => void) {
    this.refreshSubscribers.push(callback)
  }

  private onAccessTokenFetched(newToken: string) {
    this.refreshSubscribers.forEach((callback) => callback(newToken))
    this.refreshSubscribers = []
  }

  public refreshToken(): Promise<string> {
    if (!this.isRefreshing) {
      this.isRefreshing = true
      
      return getRefreshToken()
        .then((refreshToken) => { 
            if (refreshToken) {
                return axios
                    .post(routes.tokenRefresh(), {}, {
                        headers: headerToken(refreshToken)
                    })
                    .then((response) => {
                        const accessToken = response.headers['authorization'].split(' ')[1]
                        const refreshToken = response.headers['x-refresh-token']
            
                        updateAccessToken(accessToken)
                        return saveRefreshToken(refreshToken)
                    })
                    .then(() => {
                      const newToken = lastAccessToken()
                      this.onAccessTokenFetched(newToken)
                      this.isRefreshing = false
                      return newToken
                    })
            } else {
                this.isRefreshing = false
                return Promise.reject("No refresh token available")
            }
        })
        .catch((refreshError) => {
            this.isRefreshing = false
            return Promise.reject(refreshError)
        })
    }

    return new Promise<string>((resolve) => {
      this.addRefreshSubscriber(resolve)
    })
  }
}

export const tokenRefresher = new TokenRefresher()
